export default __webpack_public_path__ + "static/media/FeuerwehrAgentur_LOGO.845a497d.png";